import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url:   String,
    type:  String,
    handle: String,
    group: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      ghostClass: "opacity-50",
      draggable: "[data-sortable-item]",
      handle: this.handleValue || undefined,
      group: this.groupValue || undefined,
      onEnd: this._onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async _onEnd(evt) {
    if (evt.oldIndex === evt.newIndex && evt.from === evt.to) return

    const payload = {
      type: this.typeValue,
      id: evt.item.dataset.id,
      position: evt.newIndex + 1,
      section_id: evt.to.dataset.sectionId ?? null
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(payload)
      })

      const html = await response.text()
      if (html) window.Turbo.renderStreamMessage(html)

      if (!response.ok) this._reloadFrame()
    } catch {
      this._reloadFrame()
    }
  }

  _reloadFrame() {
    const frame = this.element.closest("turbo-frame")
    if (frame?.id) {
      window.Turbo.visit(window.location.href, { frame: frame.id })
      return
    }
    window.Turbo.visit(window.location.href)
  }
}
